/**
 * Convert an object to queryString
 * */
export function toQueryString(params) {
  return Object.keys(params).map(key => key + '=' + params[key]).join('&');
}



// WEBPACK FOOTER //
// ./app/assets/javascripts/utils/queryString.js